import Header from "@/components/layout/header";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "wouter";
import PerkWizard from "./wizard/PerkWizard";

export default function CreatePerk() {
  return (
    <div className="flex flex-col h-full">
      <Header title="Create Perk" description="Set up a new global perk for employees">
        <Link href="/perks">
          <Button variant="ghost">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Perks
          </Button>
        </Link>
      </Header>

      <div className="flex-1 overflow-auto p-6">
        <PerkWizard />
      </div>
    </div>
  );
}
